module.exports = __webpack_public_path__ + "media/images/result_sets/circles/5n4n8n7n-286c5917df82d2070bd41490bd669d12.svg";